// Shared emoji set for every text field that offers an emoji picker
// (WhatsApp templates, In-App Notification, Push Notification, ...).
// Single source of truth so the picker looks and behaves identically everywhere.
export const EMOJI_CATEGORIES = [
    {
        label: '😀',
        title: 'Smileys',
        emojis: [
            '😀','😁','😂','🤣','😃','😄','😅','😆','😇','😉','😊','😋','😌','😍','🥰','😎',
            '😏','😐','😑','😒','😓','😔','😕','🙃','🤑','😲','🥱','😴','🤤','😪','😵','🤧',
            '😷','🤒','🤕','🥴','😤','😠','😡','🤬','😈','👿','💀','☠️','💩','🤡','👹','👺',
            '👻','👽','👾','🤖','😺','😸','😹','😻','😼','😽','🙀','😿','😾','🙈','🙉','🙊',
            '💋','💌','💘','💝','💖','💗','💓','💞','💕','💟','❣️','💔','❤️','🧡','💛','💚',
            '💙','💜','🤎','🖤','🤍','💯','💢','💥','💫','💦','💨','🕳️','💬','💭','💤',
            '👋','🤚','🖐️','✋','🖖','👌','🤌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆',
            '🖕','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏','✍️',
        ],
    },
    {
        label: '👨',
        title: 'People',
        emojis: [
            '👶','🧒','👦','👧','🧑','👱','👨','🧔','👩','🧓','👴','👵','🙍','🙎','🙅','🙆',
            '💁','🙋','🧏','🙇','🤦','🤷','👮','🕵️','💂','🥷','👷','🤴','👸','👳','👲','🧕',
            '🤵','👰','🤰','🤱','👼','🎅','🤶','🦸','🦹','🧙','🧚','🧛','🧜','🧝','🧞','🧟',
            '💆','💇','🚶','🧍','🧎','🏃','💃','🕺','🕴️','👯','🧖','🧗','🤺','🏇','⛷️','🏂',
            '👫','👬','👭','💏','💑','👨‍👩‍👦','👨‍👩‍👧','👨‍👩‍👧‍👦','👨‍👦','👩‍👦','👨‍👧','👩‍👧',
            '💪','🦾','🦿','🦵','🦶','👂','🦻','👃','🫀','🫁','🧠','🦷','🦴','👀','👁️','👅','👄',
        ],
    },
    {
        label: '🐶',
        title: 'Animals',
        emojis: [
            '🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🐔',
            '🐧','🐦','🐤','🦆','🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝','🐛','🦋','🐌','🐞',
            '🐜','🦟','🦗','🕷️','🦂','🐢','🐍','🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡',
            '🐠','🐟','🐬','🐳','🐋','🦈','🐊','🐅','🐆','🦓','🦍','🦧','🦣','🐘','🦛','🦏',
            '🐪','🐫','🦒','🦘','🦬','🐃','🐂','🐄','🐎','🐖','🐏','🐑','🦙','🐐','🦌','🐕',
            '🐩','🦮','🐈','🐈‍⬛','🪶','🐓','🦃','🦤','🦚','🦜','🦢','🦩','🕊️','🐇','🦝',
            '🌵','🎄','🌲','🌳','🌴','🪵','🌱','🌿','☘️','🍀','🎍','🪴','🎋','🍃','🍂','🍁',
            '🍄','🌾','💐','🌷','🌹','🥀','🌺','🌸','🌼','🌻','🌞','🌝','🌛','🌜','🌚','🌕',
        ],
    },
    {
        label: '🍎',
        title: 'Food',
        emojis: [
            '🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝',
            '🍅','🍆','🥑','🥦','🥬','🥒','🌶️','🫑','🧄','🧅','🥔','🍠','🥐','🥯','🍞','🥖',
            '🥨','🧀','🥚','🍳','🧈','🥞','🧇','🥓','🥩','🍗','🍖','🌭','🍔','🍟','🍕','🫓',
            '🥪','🥙','🧆','🌮','🌯','🫔','🥗','🥘','🫕','🥫','🍝','🍜','🍲','🍛','🍣','🍱',
            '🥟','🦪','🍤','🍙','🍚','🍘','🍥','🥮','🍢','🧁','🍰','🎂','🍮','🍭','🍬','🍫',
            '🍿','🍩','🍪','🌰','🥜','🫘','🍯','🧃','🥤','🧋','☕','🍵','🫖','🍶','🍾','🍷',
            '🍸','🍹','🍺','🍻','🥂','🥃','🫗','🥛','🍼','🫙','🧉','🧊','🥢','🍽️','🍴','🥄',
        ],
    },
    {
        label: '✈️',
        title: 'Travel',
        emojis: [
            '🌍','🌎','🌏','🌐','🗺️','🧭','🏔️','⛰️','🌋','🗻','🏕️','🏖️','🏜️','🏝️','🏞️','🏟️',
            '🏛️','🏗️','🧱','🏘️','🏚️','🏠','🏡','🏢','🏣','🏤','🏥','🏦','🏨','🏩','🏪','🏫',
            '🏬','🏭','🏯','🏰','💒','🗼','🗽','⛪','🕌','🛕','🕍','⛩️','🕋','⛲','⛺','🌁',
            '🌃','🏙️','🌄','🌅','🌆','🌇','🌉','♨️','🎠','🎡','🎢','💈','🎪','🚂','🚃','🚄',
            '🚅','🚆','🚇','🚈','🚉','🚊','🚝','🚞','🚋','🚌','🚍','🚎','🚐','🚑','🚒','🚓',
            '🚔','🚕','🚖','🚗','🚘','🚙','🛻','🚚','🚛','🚜','🏎️','🏍️','🛵','🦽','🦼','🛺',
            '🚲','🛴','🛹','🛼','🚏','🛣️','🛤️','⛽','🚨','🚥','🚦','🛑','🚧','⚓','🛟','⛵',
            '🚤','🛥️','🛳️','⛴️','🚢','✈️','🛩️','🛫','🛬','🪂','💺','🚁','🛸','🚀','🛶','🏄',
        ],
    },
    {
        label: '⚽',
        title: 'Activities',
        emojis: [
            '⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱','🪀','🏓','🏸','🏒','🏑','🥍',
            '🏏','🪃','🥅','⛳','🪁','🎣','🤿','🎽','🎿','🛷','🥌','🎯','🪃','🏹','🎣','🤿',
            '🥊','🥋','🎖️','🏆','🥇','🥈','🥉','🏅','🎗️','🎫','🎟️','🎪','🤹','🎭','🩰','🎨',
            '🎬','🎤','🎧','🎼','🎹','🥁','🪘','🎷','🎺','🪗','🎸','🪕','🎻','🎲','♟️','🎯',
            '🎳','🎮','🎰','🧩','🪄','🎭','🎨','🖼️','🎪','🤸','🏋️','🤼','🤺','🏇','⛷️','🏂',
            '🪂','🏌️','🏄','🚣','🧗','🚵','🚴','🏊','🤽','🤾','🏃','🧘','🧗','🧜','🏋️','🤼',
        ],
    },
    {
        label: '💡',
        title: 'Objects',
        emojis: [
            '⌚','📱','📲','💻','⌨️','🖥️','🖨️','🖱️','🖲️','🕹️','🗜️','💽','💾','💿','📀','📼',
            '📷','📸','📹','🎥','📽️','🎞️','📞','☎️','📟','📠','📺','📻','🧭','⏱️','⏲️','⏰',
            '🕰️','⏳','📡','🔋','🪫','🔌','💡','🔦','🕯️','🪔','🧯','🛢️','💰','💴','💵','💶',
            '💷','💸','💳','🪙','💹','📈','📉','📊','📋','🗒️','🗓️','📆','📅','🗑️','📁','📂',
            '🗂️','🗃️','🗄️','🗑️','📊','📈','📉','📋','📌','📍','📎','🖇️','📏','📐','✂️','🗃️',
            '📝','✏️','🖊️','🖋️','🖌️','🖍️','📝','🔍','🔎','🔏','🔐','🔒','🔓','🔨','🪓','⛏️',
            '⚒️','🛠️','🗡️','⚔️','🛡️','🔧','🪛','🔩','⚙️','🗜️','⚖️','🪜','🔗','⛓️','🪝','🧲',
            '🪤','🧰','🪣','💊','💉','🩹','🩺','🩻','🩼','🧬','🔬','🔭','📡','🩸','🧪','🧫',
        ],
    },
    {
        label: '🔣',
        title: 'Symbols',
        emojis: [
            '❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖',
            '✨','⭐','🌟','💫','🔥','💥','❄️','🌊','🌀','🌈','☀️','🌤️','⛅','🌥️','☁️','🌦️',
            '🌧️','⛈️','🌩️','🌨️','❗','❕','❓','❔','‼️','⁉️','🔅','🔆','📶','📳','📴','📵',
            '🚫','🔞','🔃','🔄','🔙','🔚','🔛','🔜','🔝','🛐','⚛️','🕉️','✡️','☸️','☯️','✝️',
            '☦️','☪️','☮️','🔯','♈','♉','♊','♋','♌','♍','♎','♏','♐','♑','♒','♓',
            '⛎','🔀','🔁','🔂','▶️','⏩','⏭️','⏯️','◀️','⏪','⏮️','🔼','⏫','🔽','⏬','⏸️',
            '⏹️','⏺️','🎦','🔇','🔈','🔉','🔊','📢','📣','📯','🔔','🔕','🎵','🎶','💹','➕',
            '➖','➗','✖️','♾️','💲','💱','™️','©️','®️','〰️','➰','➿','🔚','🔛','🔜','🔝',
            '✅','☑️','🔘','🔵','🟣','⚫','🟤','🔴','🟠','🟡','🟢','🔷','🔶','🔹','🔸','🔺',
        ],
    },
];
